import { deleteWithAuth, getWithAuth, postWithAuth } from '@/api/httpRequests'

import { getErrorMessage } from '@/shared/lib'

import {
    bootstrapsKeyword,
    getFromLocalStorage,
} from '@/shared/localStorage/localStorageRepository'
import { VOD_TYPE_STREAM_IQ } from '@/clients/streamiq/shared/constantsStreamIq'
import { FavoriteItem } from '@/clients/streamiq/types/vodStreamIQTypes'
import { getBootstraps } from '@/clients/streamiq/shared/lib'

export const getFavoriteList = async (profileId: string) => {
    const bootstraps = getBootstraps()

    const favouriteListUrl =
        bootstraps?.services?.['crm-service']?.favouriteList

    const res = await getWithAuth(
        `${favouriteListUrl}?profileId=${profileId}`,
        false
    )
    if (!res) return

    return res.response
}

export const getApiFavorites = async (profileId: string) => {
    try {
        const bootstrapsObjects = getFromLocalStorage(bootstrapsKeyword)

        if (!bootstrapsObjects) return

        const bootstraps = JSON.parse(bootstrapsObjects)
        const favouriteListItemUrl =
            bootstraps?.services?.['crm-service']?.favouriteListItem
        const listResponse = await getFavoriteList(profileId)

        if (!favouriteListItemUrl) {
            throw new Error(
                'Favorite list URL not found in bootstraps configuration'
            )
        }

        if (
            !listResponse ||
            !listResponse.resources ||
            listResponse.resources.length === 0
        ) {
            console.log('No favorite lists found')
            return []
        }

        const favouriteListId = listResponse.resources[0].id

        const res = await getWithAuth(
            `${favouriteListItemUrl}?favouriteListId=${favouriteListId}`,
            false
        )

        if (!res) return

        const { response } = res

        if (!response || !response.resources) {
            console.log('No favorite items found')
            return []
        }

        return response.resources
    } catch (error) {
        getErrorMessage('getApiFavorites - Fetching favorites failed', error)
        throw new Error('Failed to fetch favorite items')
    }
}

export const markApiFavoriteItem = async (
    profileId: string,
    productType: string,
    productId: string
) => {
    const bootstraps = JSON.parse(
        getFromLocalStorage(bootstrapsKeyword) || '{}'
    )
    const favoriteListItemsUrl =
        bootstraps.services['crm-service']?.favouriteListItem

    if (!favoriteListItemsUrl) {
        console.error(
            'Favorite List Items URL not found in bootstrap configuration.'
        )
        return
    }
    const listResponse = await getFavoriteList(profileId)
    const favouriteListId = listResponse.resources[0].id
    if (!favouriteListId) return

    const requestBody = JSON.stringify({
        favouriteListId,
        ordinal: 0,
        reference: {
            id: productId,
            type: productType,
            serviceName: VOD_TYPE_STREAM_IQ.includes(productType)
                ? 'vod-service'
                : 'epg-service',
        },
        type: 'favorite',
        serviceName: 'favorite-service',
    })
    try {
        return await postWithAuth(favoriteListItemsUrl, false, requestBody)
    } catch (error) {
        getErrorMessage('markFavoriteItem', error)
        throw new Error('Failed to mark item as favorite')
    }
}

export const unMarkApiFavoriteItem = async (
    productId: string,
    profileId?: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _productType?: string
) => {
    try {
        const bootstraps = JSON.parse(
            getFromLocalStorage(bootstrapsKeyword) || '{}'
        )
        const favoriteListItemsUrl =
            bootstraps.services['crm-service']?.favouriteListItem
        const favorites = await getApiFavorites(profileId || '')

        const itemToUnmark = favorites.find(
            (item: FavoriteItem) => item.reference.id === productId
        )
        await deleteWithAuth(
            `${favoriteListItemsUrl}/${itemToUnmark.id}`,
            false
        )
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('un mark channel as favorite failure')
    }
}
